import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../../services/http.service';
import { CustomToastComponent } from '../../toast/custom-toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-gallery-view',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './gallery-view.component.html',
  styleUrls: ['./gallery-view.component.scss'],
})
export class GalleryComponent implements OnInit, OnDestroy {
  @Output() imageSelected = new EventEmitter<any>();

  isLoading: boolean = false;
  mediaItems: any[] = [];
  selectedImageId: string | null = null;
  selectedImage: any = null;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GalleryComponent>,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  ngOnInit(): void {
    this.loadMediaItems();
  }

  loadMediaItems(): void {
    this.isLoading = true;

    this.httpService
      .get('eventtypes/getassetsimage')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (response: any) => {
          if (response?.status && response?.data) {
            this.mediaItems = response.data;
          }
        },
        error: (err: any) => {
          console.error('Failed to load media:', err);
          this.showErrorToast(err?.message || 'Failed to load media');
        },
      });
  }

  toggleSelection(item: any): void {
    if (this.selectedImageId === item.id) {
      this.selectedImageId = null;
      this.selectedImage = null;
    }
    else {
      this.selectedImageId = item.id;
      this.selectedImage = item;
    }
  }

  handleImageError(event: any): void {
    event.target.src = 'assets/images/placeholder-image.jpg';
  }

  onSelect(): void {
    if (this.selectedImage) {
      this.dialogRef.close(this.selectedImage);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message, type: 'success' },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['success-toast'],
    });
  }

  private showErrorToast(message: string): void {
    if (!message) return;
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message, type: 'error' },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['error-toast'],
    });
  }
}